/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionCountdownLazy_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionCountdown_item">;
    readonly " $refType": "PdpSharedAuctionCountdownLazy_item";
};
export type PdpSharedAuctionCountdownLazy_item$data = PdpSharedAuctionCountdownLazy_item;
export type PdpSharedAuctionCountdownLazy_item$key = {
    readonly " $data"?: PdpSharedAuctionCountdownLazy_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionCountdownLazy_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionCountdownLazy_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdown_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '2009c46cfc14499747c09c66dde3694b';
export default node;
